import { getRegisterFunction } from '../../utils/register.js';
import { OneUxContextualTreeElement } from './OneUxContextualTreeElement.js';
export const register = getRegisterFunction(OneUxContextualTreeElement);
declare global {
  interface HTMLElementTagNameMap {
    'contextual-one-ux-tree': OneUxContextualTreeElement;
    'one-ux-contextual-tree': OneUxContextualTreeElement;
    "contextual-tree-b5ad3d1d31431a9f421374501f5eed7e": OneUxContextualTreeElement;
  }
}